export default __webpack_public_path__ + "static/Do-Nesting-8413912f1f71103a7c02d4fea3f2eb09.png";